import { add, differenceInDays, differenceInHours, differenceInMinutes, differenceInMonths, differenceInWeeks, differenceInYears } from "date-fns";

export const getDateDiffInDays = (start: Date, finish: Date) => {
  const diffTime = finish.getTime() - start.getTime();

  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};

export const getDateDiffFormatted = (start: Date, finish: Date) => {
  const yearsDiff = differenceInYears(start, finish);
  const monthsDiff = differenceInMonths(start, finish);
  const weeksDiff = differenceInWeeks(start, finish);
  const daysDiff = differenceInDays(start, finish);
  const hoursDiff = differenceInHours(start, finish);
  const minutesDiff = differenceInMinutes(start, finish);

  if (yearsDiff > 0) {
    return `${yearsDiff} ${yearsDiff > 1 ? 'anos' : 'ano'}`;
  }

  if (monthsDiff > 0) {
    return `${monthsDiff} ${monthsDiff > 1 ? 'meses' : 'mês'}`;
  }

  if (weeksDiff > 0) {
    return `${weeksDiff} ${weeksDiff > 1 ? 'semanas' : 'semana'}`;
  }

  if (daysDiff > 0) {
    return `${daysDiff} ${daysDiff > 1 ? 'dias' : 'dia'}`;
  }

  if (hoursDiff > 0) {
    return `${hoursDiff} ${hoursDiff > 1 ? 'horas' : 'hora'}`;
  }

  if (minutesDiff > 0) {
    return `${minutesDiff} ${minutesDiff > 1 ? 'minutos' : 'minuto'}`;
  }

  return '< 1 minuto'
};

export const getFullDateDiffFormatted = (start: Date, finish: Date) => {
  let current = finish;

  const years = differenceInYears(start, current);
  current = add(current, { years });

  const months = differenceInMonths(start, current);
  current = add(current, { months });

  const weeks = differenceInWeeks(start, current);
  current = add(current, { weeks });

  const days = differenceInDays(start, current);
  current = add(current, { days });

  const hours = differenceInHours(start, current);
  current = add(current, { hours });

  const minutes = differenceInMinutes(start, current);
  current = add(current, { minutes });

  const diffs: string[] = [];

  if (years) diffs.push(`${years} ${years > 1 ? 'anos' : 'ano'}`);
  if (months) diffs.push(`${months} ${months > 1 ? 'meses' : 'mês'}`);
  if (weeks) diffs.push(`${weeks} ${weeks > 1 ? 'semanas' : 'semana'}`);
  if (days) diffs.push(`${days} ${days > 1 ? 'dias' : 'dia'}`);
  if (hours) diffs.push(`${hours} ${hours > 1 ? 'horas' : 'hora'}`);
  if (minutes) diffs.push(`${minutes} ${minutes > 1 ? 'minutos' : 'minuto'}`);

  if (diffs.length === 0) return '< 1 minuto';
  if (diffs.length === 1) return diffs[0];
  if (diffs.length === 2) return `${diffs[0]} e ${diffs[1]}`;

  return `${diffs.slice(0, -1).join(', ')} e ${diffs.at(-1)}`;
};
